<template>
  <v-layout>
    <v-flex class="scroll-y">

      <v-item-group v-model="onboarding" class="text-xs-center" mandatory>
          <v-item v-for="index in items.length" :key="index">
            <v-btn slot-scope="{ active, toggle }" @click="toggle" icon small flat :color="active ? 'primary' : '#0d25491f'">
              <v-icon size="18">fiber_manual_record</v-icon>
            </v-btn>
          </v-item>
        </v-item-group>

      <v-btn icon @click="isActive = false" right absolute dark class="mt-2" style="z-index: 10">
        <v-icon>clear</v-icon>
      </v-btn>

      <div class="gradient-container">
        <v-responsive width="99%" class="">

          <v-btn flat @click="prev" absolute left icon>
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <v-btn flat @click="next" absolute right icon>
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-responsive>

      </div>

      <v-window v-model="onboarding">
        <v-window-item v-for="(item, index) in items" :key="index">
          <div class="part">
            <div width="50%">
              <div class="pa-4 mr-5">
                <div class="display-1 font-weight-bold mb-2">{{ item.title }}</div>
                <div class="subheading">{{ item.text }}</div>
              </div>
              <div>
                <v-responsive width="100%" class="image-container">
                  <v-card class="elevation-8">
                    <v-img :src="item.image" width="100%" height="100%"/>
                  </v-card>
                </v-responsive>
              </div>
            </div>
            <div class="pa-4 ml-5" width="50%">
              <div class="display-1 font-weight-bold mb-2">{{ item.title_use }}</div>
              <!--<div class="subheading">{{ item.text }}</div>-->
              <div class="subheading mb-4">{{ item.use }}</div>
              <div class="part">
                <v-responsive width="50%" class="image-container">
                  <v-card class="elevation-8">
                    <v-img :src="item.image2" width="100%"/>
                  </v-card>
                </v-responsive>
                <v-responsive width="50%" class="image-container">
                  <v-card class="elevation-8">
                    <v-img :src="item.image3" width="100%"/>
                  </v-card>
                </v-responsive>
              </div>
            </div>
          </div>
        </v-window-item>
      </v-window>

    </v-flex>
  </v-layout>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
//  TODO: finire testo guida
export default {
    name: 'OnBoardingDialog',
    mixins: [Toggleable],
    data () {
        return {
            onboarding: 0
        }
    },
    computed: {
      items() {
        return [
          { title: this.$t('onboarding.avvisi.title'), text: this.$t('onboarding.avvisi.text'), use: this.$t('onboarding.avvisi.use'), title_use: this.$t('onboarding.avvisi.title_use'), image: require('@/assets/onboarding/avvisi.png'), image2: require('@/assets/onboarding/nuovo_avviso.png'), image3: require('@/assets/onboarding/nuovo_avviso_popup.png') },
          { title: this.$t('onboarding.report.title'), text: this.$t('onboarding.report.text'), use: this.$t('onboarding.report.use'), title_use: this.$t('onboarding.report.title_use'), image: require('@/assets/onboarding/reports.png'), image2: require('@/assets/onboarding/reports_info.png'), image3: require('@/assets/onboarding/reports_allegati.png') },
          { title: this.$t('onboarding.prenotazioni.title'), text: this.$t('onboarding.prenotazioni.text'), use: this.$t('onboarding.prenotazioni.use'), title_use: this.$t('onboarding.prenotazioni.title_use'), image: require('@/assets/onboarding/calendario.png'), image2: require('@/assets/onboarding/prenotazioni_info.png'), image3: require('@/assets/onboarding/prenotazioni_edit.png') },
          { title: this.$t('onboarding.map.title'), text: this.$t('onboarding.map.text'), use: this.$t('onboarding.map.use'), title_use: this.$t('onboarding.map.title_use'), image: require('@/assets/onboarding/mappa.png'), image2: require('@/assets/onboarding/mappa_tragitto.png'), image3: require('@/assets/onboarding/mappa_tecnico.png') },
          { title: this.$t('onboarding.clienti.title'), text: this.$t('onboarding.clienti.text'), use: this.$t('onboarding.clienti.use'), title_use: this.$t('onboarding.magazzino.title_use'), image: require('@/assets/onboarding/clienti_info.png'), image2: require('@/assets/onboarding/clienti_edit.png'), image3: require('@/assets/onboarding/clienti_add.png')},
          { title: this.$t('onboarding.convenzioni.title'), text: this.$t('onboarding.convenzioni.text'), use: this.$t('onboarding.convenzioni.use'), title_use: this.$t('onboarding.convenzioni.title_use'), image: require('@/assets/onboarding/convenzioni.png'), image2: require('@/assets/onboarding/convenzione.png') },
          { title: this.$t('onboarding.magazzino.title'), text: this.$t('onboarding.magazzino.text'), use: this.$t('onboarding.magazzino.use'), title_use: this.$t('onboarding.magazzino.title_use'), image: require('@/assets/onboarding/magazzino.png'), image2: require('@/assets/onboarding/ugelli.png') },
          { title: this.$t('onboarding.unita_mobili.title'), text: this.$t('onboarding.unita_mobili.text'), use: this.$t('onboarding.unita_mobili.use'), title_use: this.$t('onboarding.unita_mobili.title_use'), image: require('@/assets/onboarding/unita_mobili.png'), image2: require('@/assets/onboarding/mobile_info.png') },
          { title: this.$t('onboarding.tecnici.title'), text: this.$t('onboarding.tecnici.text'), use: this.$t('onboarding.tecnici.use'), title_use: this.$t('onboarding.tecnici.title_use'), image: require('@/assets/onboarding/tecnici.png'), image2: require('@/assets/onboarding/tecnici_info.png'), image3: require('@/assets/onboarding/tecnici_stats.png') },
          { title: this.$t('onboarding.statistiche.title'), text: this.$t('onboarding.statistiche.text'), use: this.$t('onboarding.statistiche.use'), title_use: this.$t('onboarding.statistiche.title_use'), image: require('@/assets/onboarding/stats_3.png'), image2: require('@/assets/onboarding/stats_1.png'), image3: require('@/assets/onboarding/stats_2.png') }
        ]
      }
      
    },
    mounted () {
        window.addEventListener('wheel', this.onScroll, { passive: true })
    },
    beforeDestroy () {
        window.removeEventListener('wheel', this.onScroll)
    },
    methods: {
        show () {
            this.isActive = true
        },
        next () {
            this.onboarding = (this.onboarding < this.items.length - 1) ? this.onboarding + 1 : 0
        },
        prev () {
            this.onboarding = (this.onboarding > 0) ? this.onboarding - 1 : this.items.length - 1
        },
        onScroll (e) {
            if (e.deltaY < 0 || e.deltaX < 0) { //  Up
                this.prev()
            } else if (e.deltaY > 0 || e.deltaX > 0) { //  Down
                this.next()
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .gradient-container {
    position: absolute;
    left: 0;
    right: 0;

    .v-responsive {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .v-btn {
      z-index: 10;
      top: calc(50% - 18px);
    }
  }

  .image-container {
    .v-card {
      width: 100%;
      height:100%;
      margin: auto auto auto;
    }
  }

  .part {
    display: flex;
    justify-content: center;
  }

</style>
